function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-04a2e21d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RestitutionBouteilles.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RestitutionBouteilles.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-04a2e21d\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RestitutionBouteilles.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04a2e21d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/bouteille/RestitutionBouteilles.vue
// module id = 945
// module chunks = 0